import { ActionTypesScreen7 } from "app/constants";

export const defaultState = {
  leftMenudata: [],
  treeMapData: [],
  pipelineData: [],
  feederData: [],
};

function Screen6Reducer(state = defaultState, action) {
  switch (action.type) {
    case ActionTypesScreen7.GET_LEFT_MENU_DATA_SCREEN7:
      return { ...state, leftMenudata: action.payload };
    case ActionTypesScreen7.GET_TREE_MAP_DATA_SCREEN7:
      return { ...state, treeMapData: action.payload };
    case ActionTypesScreen7.GET_BAR_CHART_SCREEN7:
      return { ...state, pipelineData: action.payload };
    case ActionTypesScreen7.GET_FEEDERS_DATA_SCREEN7:
      return { ...state, feederData: action.payload };
    default:
      return state;
  }
}

export default Screen6Reducer;
